import React, { Component } from 'react';
import Loading from '../../Loading.js'
import ControlMessages from './ControlMessages.js';
import { getProjectMessages } from '../../../Api/ExtranetActions.js'

declare var globalSns;
declare var $;

class ExtranetProjectsMessages extends Component {
    constructor(props) {
        super(props);

        this.state = {}
        
        this.reload = this.reload.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getProjectMessages(this.props.id, globalSns.languageId, (data) => {
            this.setState({
                projectMessages: data
            });
        });
    }

    reload() {
        this.loadData();
    }

    render() {
        if (this.state.projectMessages == null) {
            return (
                <Loading/>
            );
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <ControlMessages messages={this.state.projectMessages}
                        projectId={this.props.id}
                        projectName={this.props.title}
                        onNavigateToCandidates={(row) => this.props.onNavigate("extranetCandidatesFiche", row.candidateId, row.candidateFirstName + " " + row.candidateName)} 
                        onReload={this.reload} />
                </div>
            </div>
        );
    }
}

export default ExtranetProjectsMessages;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ExtranetProjectsMessages.js